export const Movies = [
    {
        type: "Movies",
        name: "⭐️ Dominion (2018)",
        category: "Animals",
        author: "",
        description:
            "Dominion uses drones, hidden and handheld cameras to expose the dark underbelly of modern animal agriculture, questioning the morality and validity of humankind's dominion over the animal kingdom. While mainly focusing on animals used for food, it also explores other ways animals are exploited and abused by humans, including clothing, entertainment and research",
        link: "https://www.youtube.com/watch?v=ny6aqdFy9SI",
        "": "",
    },
    {
        type: "Movies",
        name: "Cowspiracy (2014)",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.netflix.com/watch/80033772",
        "": "",
    },
    {
        type: "Movies",
        name: "What The Health (2017)",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.netflix.com/nl-en/title/80174177",
        "": "",
    },
    {
        type: "Movies",
        name: "Forks Over Knives (2011)",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.forksoverknives.com/the-film/",
        "": "",
    },
    {
        type: "Movies",
        name: "Land of Hope and Glory (2017)",
        category: "Animals",
        author: "",
        description: "",
        link: "https://www.youtube.com/watch?v=dvtVkNofcq8",
        "": "",
    },
    {
        type: "Movies",
        name: "Meet Your Meat (2012)",
        category: "Animals",
        author: "",
        description: "",
        link: "https://www.peta.org/videos/meet-your-meat/",
        "": "",
    },
    {
        type: "Movies",
        name: "Speciesism: The Movie (2013)",
        category: "Animals",
        author: "",
        description: "",
        link: "https://speciesismthemovie.com/",
        "": "",
    },
    {
        type: "Movies",
        name: "Earthlings (2005)",
        category: "Animals",
        author: "",
        description: "",
        link: "https://www.youtube.com/watch?v=8gqwpfEcBjI",
        "": "",
    },
    {
        type: "Movies",
        name: "The Game Changers (2019)",
        category: "Fitness",
        author: "",
        description: "",
        link: "https://gamechangersmovie.com/",
        "": "",
    },
    {
        type: "Movies",
        name: "My Octopus Teacher (2020)",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.netflix.com/title/81045007",
        "": "",
    },
    {
        type: "Movies",
        name: "Milked (2021)",
        category: "Animals",
        author: "",
        description: "",
        link: "https://www.youtube.com/watch?v=MCwpsMtmMhM",
        "": "",
    },
    {
        type: "Movies",
        name: "Seaspiracy (2021)",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.netflix.com/title/81014008",
        "": "",
    },
    {
        type: "Movies",
        name: "Countdown To Year Zero (2019)",
        category: "Enviornment",
        author: "",
        description: "",
        link: "https://watch.unchainedtv.com/apps/3909/167038/189585/45777062",
        "": "",
    },
    {
        type: "Movies",
        name: "Akashinga: The Brave Ones",
        category: "Documentary",
        author: "",
        description: "Animals, Animal welfare, Human rights",
        link: "https://www.youtube.com/watch?v=WUYQS40I9mw&t=4s",
        "": "",
    },
    {
        type: "Movies",
        name: "Animals: A Parallel History",
        category: "Documentary",
        author: "",
        description: "Animals, Factory Farms, Human rights",
        link: "https://www.youtube.com/watch?v=D-uxbUqAhSc",
        "": "",
    },
    {
        type: "Movies",
        name: "Avatar",
        category: "Adventure, Action, Fantasy, Sci-fi",
        author: "",
        description: "Environment, Spirituality, Sustainability",
        link: "https://www.youtube.com/watch?v=5PSNL1qE6VY",
        "": "",
    },
    {
        type: "Movies",
        name: "Baby Hers",
        category: "Documentary",
        author: "",
        description: "Animals, Animal rights, Animal welfare",
        link: "https://vimeo.com/429115594",
        "": "",
    },
    {
        type: "Movies",
        name: "Butenland",
        category: "Documentary",
        author: "",
        description: "Animals, Animal rights, Veganism",
        link: "https://vimeo.com/ondemand/butenland/365231651",
        "": "",
    },
    {
        type: "Movies",
        name: "Carnage",
        category: "Comedy",
        author: "",
        description:
            "Animal rights, Animal welfare, Vegan character, Vegan message, Veganism",
        link: "https://www.youtube.com/watch?v=dIryT5TFLRQ",
        "": "",
    },
    {
        type: "Movies",
        name: "Emptying the Skies",
        category: "Documentary",
        author: "",
        description: "n/a",
        link: "n/a",
        "": "",
    },
    {
        type: "Movies",
        name: "Endgame 2050",
        category: "Documentary, Drama",
        author: "",
        description: "Animal rights, Birds, Cancer, Climate change, Pollution",
        link: "https://www.youtube.com/watch?v=_PTtF6btAxU",
        "": "",
    },
    {
        type: "Movies",
        name: "Fantastic Fungi",
        category: "Documentary",
        author: "",
        description: "Reddit",
        link: "https://www.youtube.com/watch?v=bxABOiay6oA&t=2s",
        "": "",
    },
    {
        type: "Movies",
        name: "Ferngully 2: The Magical Rescue",
        category: "Adventure, Animation, Family, Fantasy",
        author: "",
        description: "Animal rights, Animal welfare",
        link: "https://www.youtube.com/watch?v=qd5mYLGdPgU",
        "": "",
    },
    {
        type: "Movies",
        name: "Ferngully: The Last Rainforest",
        category: "Adventure, Animation, Family, Fantasy",
        author: "",
        description: "Environment, Pollution, Sustainability",
        link: "https://www.youtube.com/watch?v=r8RsJcd0-js",
        "": "",
    },
    {
        type: "Movies",
        name: "Fillet-Oh-Fish",
        category: "Documentary",
        author: "",
        description:
            "Animal welfare, Environment, Health, Marine life, Pollution, Sustainability, Water",
        link: "https://www.youtube.com/watch?v=ag0Y9xCatM8",
        "": "",
    },
    {
        type: "Movies",
        name: "Fly Away Home",
        category: "Adventure, Drama, Family",
        author: "",
        description: "Animals, Birds",
        link: "https://www.youtube.com/watch?v=FCjlubLJcxk",
        "": "",
    },
    {
        type: "Movies",
        name: "Fowl Play",
        category: "Documentary",
        author: "",
        description: "Animal rights, Animal welfare, Birds",
        link: "https://vimeo.com/1980424",
        "": "",
    },
    {
        type: "Movies",
        name: "From the Ground Up",
        category: "Documentary",
        author: "",
        description: "Animal rights, Environment, Fitness, Health, Vegan message",
        link: "https://www.youtube.com/watch?v=48DZlvgMITw",
        "": "",
    },
    {
        type: "Movies",
        name: "Furry Vengeance",
        category: "Comedy, Family",
        author: "",
        description: "Animals, Environment",
        link: "https://www.youtube.com/watch?v=zUBDUWpB14s",
        "": "",
    },
    {
        type: "Movies",
        name: "Give Me Shelter",
        category: "Documentary",
        author: "",
        description: "Animal rights, Animal welfare",
        link: "https://www.youtube.com/watch?v=z41UiRpd2YE",
        "": "",
    },
    {
        type: "Movies",
        name: "Global Thermostat",
        category: "Documentary",
        author: "",
        description: "Climate change, Environment, Pollution",
        link: "https://www.youtube.com/watch?v=u872uy3IlUA",
        "": "",
    },
    {
        type: "Movies",
        name: "Go Further",
        category: "Documentary",
        author: "",
        description: "Environment, Sustainability",
        link: "https://www.youtube.com/watch?v=qXDmVXqH018",
        "": "",
    },
    {
        type: "Movies",
        name: "Got the Facts on Milk? The Milk Documentary",
        category: "Documentary",
        author: "",
        description:
            "Animal rights, Animal welfare, Cancer, Dairy impact, Diabetes, Health, Heart disease",
        link: "https://www.youtube.com/watch?v=8m6VErjH5VY",
        "": "",
    },
    {
        type: "Movies",
        name: "Happy Feet",
        category: "Adventure, Animation, Comedy, Family, Musical, Romance",
        author: "",
        description: "Animals, Environment, Marine life, Sustainability",
        link: "https://www.youtube.com/watch?v=2q3L63bSn5M",
        "": "",
    },
    {
        type: "Movies",
        name: "Happy Feet Two",
        category: "Adventure, Animation, Comedy, Family, Musical, Romance",
        author: "",
        description: "Animal welfare, Climate change, Environment",
        link: "https://www.youtube.com/watch?v=1w0prf_DKeE",
        "": "",
    },
    {
        type: "Movies",
        name: "For the Birds",
        category: "Documentary",
        author: "",
        description: "Animal welfare, Animals, Birds",
        link: "https://www.youtube.com/watch?v=kfUY9lraOKU",
        "": "",
    },
    {
        type: "Movies",
        name: "Hogwood: A Modern Horror Story",
        category: "Documentary",
        author: "",
        description: "Animal rights, Animal welfare, Factory farms",
        link: "https://www.youtube.com/watch?v=v_kHNUwm3Yw",
        "": "",
    },
    {
        type: "Movies",
        name: "Home On The Range Benefit Documentary",
        category: "Documentary",
        author: "",
        description: "Animal welfare",
        link: "https://www.youtube.com/watch?v=Fhy0Gnempys",
        "": "",
    },
    {
        type: "Movies",
        name: "Hoot",
        category: "Adventure, Comedy, Family",
        author: "",
        description: "Animals",
        link: "https://www.youtube.com/watch?v=gEmdJAp_M8k",
        "": "",
    },
    {
        type: "Movies",
        name: "How To Change The World",
        category: "Adventure, Documentary",
        author: "",
        description: "Animals, Environment, Free speech, Marine life",
        link: "https://vimeo.com/ondemand/howtochangetheworld2",
        "": "",
    },
    {
        type: "Movies",
        name: "I Am an Animal: The Story of Ingrid Newkirk and PETA",
        category: "Documentary",
        author: "",
        description: "Animal rights, Animal welfare",
        link: "https://www.youtube.com/watch?v=aZ1Xr-gerAw",
        "": "",
    },
    {
        type: "Movies",
        name: "I am Greta",
        category: "Documentary",
        author: "",
        description: "Climate Change, Environment, Vegan character",
        link: "https://www.iamgretafilm.com/trailer",
        "": "",
    },
    {
        type: "Movies",
        name: "Immi the Vegan",
        category: "Comedy, Musical, Romance",
        author: "",
        description: "Vegan character, Veganism",
        link: "https://www.youtube.com/watch?v=8_yEQWPCInw",
        "": "",
    },
    {
        type: "Movies",
        name: "Kedi",
        category: "Documentary",
        author: "",
        description: "Animals, Animal welfare",
        link: "https://www.youtube.com/watch?v=lKq7UqplcL8",
        "": "",
    },
    {
        type: "Movies",
        name: "Keiko: The Untold Story of the Star of Free Willy",
        category: "Documentary",
        author: "",
        description: "Animals, Animal welfare, Marine life",
        link: "https://www.youtube.com/watch?v=iABmsWUv2qM",
        "": "",
    },
    {
        type: "Movies",
        name: "Kindred Creatures",
        category: "Documentary",
        author: "",
        description: "Animal rights, Animal welfare, Vegan message",
        link: "https://vimeo.com/284545292",
        "": "",
    },
    {
        type: "Movies",
        name: "Land of Hope and Glory",
        category: "Documentary",
        author: "",
        description: "Animal rights, Animal welfare, Vegan message",
        link: "https://www.youtube.com/watch?v=OqPflP_hXyY",
        "": "",
    },
    {
        type: "Movies",
        name: "Leviathan",
        category: "Documentary",
        author: "",
        description: "",
        link: "https://www.youtube.com/watch?v=YZcP3l0Te4M",
        "": "",
    },
    {
        type: "Movies",
        name: "Long Gone Wild",
        category: "Documentary",
        author: "",
        description: "Animal rights, Animal welfare, Animals, Marine life",
        link: "https://www.youtube.com/watch?v=C5T2AOjpSZs",
        "": "",
    },
    {
        type: "Movies",
        name: "McLibel",
        category: "Documentary",
        author: "",
        description:
            "Animal rights, Animal welfare, Environment, Free speech, Health",
        link: "https://www.youtube.com/watch?v=LyGK5j_EcmE",
        "": "",
    },
    {
        type: "Movies",
        name: "May I Be Frank",
        category: "Comedy, Documentary, Drama",
        author: "",
        description: "Health, Obesity, Vegan message",
        link: "https://www.youtube.com/watch?v=9kYXrvNkdSc",
        "": "",
    },
    {
        type: "Movies",
        name: "Meat the Future",
        category: "",
        author: "",
        description: "Animals, Environment, Sustainability",
        link: "https://www.youtube.com/watch?v=xfdaQmR0mxk",
        "": "",
    },
    {
        type: "Movies",
        name: "Minds in the Water",
        category: "Action, Adventure, Documentary",
        author: "",
        description: "Animals, Animal welfare, Marine life",
        link: "https://www.youtube.com/watch?v=tnoMSxWfZBI&t=1s",
        "": "",
    },
    {
        type: "Movies",
        name: "The World According to Monsanto",
        category: "Documentary",
        author: "",
        description: "Environment, Farmers, Free speech, Pollution",
        link: "https://www.youtube.com/watch?v=z8hFuuDAZjk",
        "": "",
    },
    {
        type: "Movies",
        name: "Naledi: A Baby Elephant's Tale",
        category: "Documentary",
        author: "",
        description: "Animals, Animal welfare",
        link: "https://www.youtube.com/watch?v=BTp2XuuvHBc&t=1s",
        "": "",
    },
    {
        type: "Movies",
        name: "New Day New Chef",
        category: "Series",
        author: "",
        description: "Vegan character, Veganism",
        link: "https://vimeo.com/386136417",
        "": "",
    },
    {
        type: "Movies",
        name: "New Day New Chef: Support and Feed Edition",
        category: "Series",
        author: "",
        description: "Veganism, Vegan character, Vegan message",
        link: "https://www.youtube.com/watch?v=ujRPPVPgySY",
        "": "",
    },
    {
        type: "Movies",
        name: "Open Season",
        category: "Adventure, Animation, Comedy, Family",
        author: "",
        description: "Animals, Animal rights",
        link: "https://www.youtube.com/watch?v=1KFSjLvEfts",
        "": "",
    },
    {
        type: "Movies",
        name: "Processed People",
        category: "Documentary",
        author: "",
        description:
            "Cancer, Dairy impact, Diabetes, Fitness, Health, Heart disease, obesity",
        link: "https://www.youtube.com/watch?v=VQNNX2Oo7Kk",
        "": "",
    },
    {
        type: "Movies",
        name: "Rio",
        category: "Adventure, Animation, Comedy, Crime, Family, Musical",
        author: "",
        description: "Animals, Animal rights, Birds",
        link: "https://www.youtube.com/watch?v=lDsvbki-3IM",
        "": "",
    },
    {
        type: "Movies",
        name: "Project Nim",
        category: "Documentary",
        author: "",
        description: "Animal rights, Animal welfare",
        link: "https://www.youtube.com/watch?v=IHoviCO7lpE",
        "": "",
    },
    {
        type: "Movies",
        name: "Queen of the Sun: What Are the Bees Telling Us?",
        category: "Documentary",
        author: "",
        description: "Animal welfare, Environment, Pollution",
        link: "https://www.youtube.com/watch?v=ekoeQodrVoM",
        "": "",
    },
    {
        type: "Movies",
        name: "Rio 2",
        category: "Adventure, Animation, Comedy, Family, Musical",
        author: "",
        description: "Animal rights, Animals, Birds, Environment, Sustainability",
        link: "https://www.youtube.com/watch?v=JtP7zka5UI8",
        "": "",
    },
    {
        type: "Movies",
        name: "Saving Jaws",
        category: "Documentary",
        author: "",
        description: "Animals, Marine life",
        link: "https://www.youtube.com/watch?v=AbAeyHfmY8M",
        "": "",
    },
    {
        type: "Movies",
        name: "Seaspiracy",
        category: "Documentary",
        author: "",
        description: "Animals, Environment, Sustainability",
        link: "https://youtu.be/1Q5CXN7soQg",
        "": "",
    },
    {
        type: "Movies",
        name: "Second Chance Dogs",
        category: "Documentary",
        author: "",
        description: "Animal welfare",
        link: "https://www.youtube.com/watch?v=4mgLFXAzI0Q",
        "": "",
    },
    {
        type: "Movies",
        name: "Shark Tale",
        category: "Adventure, Animation, Comedy, Family, Fantasy",
        author: "",
        description: "Animals, Marine life, Vegan character",
        link: "https://www.youtube.com/watch?v=Ta5DtOI5kIU",
        "": "",
    },
    {
        type: "Movies",
        name: "Sharkwater",
        category: "Documentary",
        author: "",
        description: "Animal rights, Animal welfare, Marine life",
        link: "https://www.youtube.com/watch?v=m5fObF_CCYc",
        "": "",
    },
    {
        type: "Movies",
        name: "Sharkwater Extinction",
        category: "Documentary",
        author: "",
        description: "Animal rights, Animal welfare, Marine life",
        link: "https://www.youtube.com/watch?v=RQYHBrtYsnk",
        "": "",
    },
    {
        type: "Movies",
        name: "Slaughterhouse: What the meat industry hides",
        category: "Documentary",
        author: "",
        description: "Animal rights, Animal welfare",
        link: "https://www.youtube.com/watch?v=0VbTT5GUqBk",
        "": "",
    },
    {
        type: "Movies",
        name: "Sled Dogs",
        category: "Documentary",
        author: "",
        description: "Animal rights, Animal welfare",
        link: "https://www.youtube.com/watch?v=uDALaa3mADE",
        "": "",
    },
    {
        type: "Movies",
        name: "Sonic Sea",
        category: "Documentary",
        author: "",
        description: "Animal welfare, Animals, Marine life",
        link: "https://vimeo.com/233044605",
        "": "",
    },
    {
        type: "Movies",
        name: "Spirit",
        category: "Adventure, Animation, Drama, Family",
        author: "",
        description: "Animals, Animal rights",
        link: "https://www.youtube.com/watch?v=RPJ4EQ2Eh9I",
        "": "",
    },
    {
        type: "Movies",
        name: "Street Dogs of South Central",
        category: "Documentary",
        author: "",
        description: "Animals, Animal welfare, Dogs",
        link: "https://www.youtube.com/watch?v=jjHIwoblf2c",
        "": "",
    },
    {
        type: "Movies",
        name: "Swimming to Sea",
        category: "Animation, Drama, Horror",
        author: "",
        description: "Animal rights, Animal welfare, Marine life",
        link: "https://www.youtube.com/watch?v=BqdxBvnsWBI",
        "": "",
    },
    {
        type: "Movies",
        name: "Takeout",
        category: "Documentary",
        author: "",
        description: "Animals, cancer, climate change, Heart disease, Memory",
        link: "https://vimeo.com/400004380",
        "": "",
    },
    {
        type: "Movies",
        name: "Test Subjects",
        category: "Documentary",
        author: "",
        description: "Animal rights, Animal welfare, Animals",
        link: "https://vimeo.com/373571473",
        "": "",
    },
    {
        type: "Movies",
        name: "The 11th Hour",
        category: "Documentary",
        author: "",
        description: "Climate change, Environment, Sustainability",
        link: "https://www.youtube.com/watch?v=ENcV5zeMILs",
        "": "",
    },
    {
        type: "Movies",
        name: "The Animal People",
        category: "Documentary",
        author: "",
        description: "Animal rights, Animal welfare, Free speech",
        link: "https://www.youtube.com/watch?v=IXcmqguK3DE",
        "": "",
    },
    {
        type: "Movies",
        name: "The Animals Film",
        category: "Documentary",
        author: "",
        description: "Animal rights, Animal welfare",
        link: "https://www.youtube.com/watch?v=xjRi_pcuzDM",
        "": "",
    },
    {
        type: "Movies",
        name: "The Big Fat Lie",
        category: "Documentary",
        author: "",
        description:
            "Cancer, Dairy impact, Diabetes, Health, Heart disease, Obesity",
        link: "https://vimeo.com/360682604",
        "": "",
    },
    {
        type: "Movies",
        name: "The Champions",
        category: "Documentary",
        author: "",
        description: "Animal welfare",
        link: "https://www.youtube.com/watch?v=otgbBDaZzCw",
        "": "",
    },
    {
        type: "Movies",
        name: "The Elephant in the Living Room",
        category: "Documentary",
        author: "",
        description: "Animal rights, Animal welfare",
        link: "https://www.youtube.com/watch?v=IGXLsvZHouA",
        "": "",
    },
    {
        type: "Movies",
        name: "The End of the Line",
        category: "Documentary",
        author: "",
        description: "Animal welfare, Environment, Marine life, Sustainability",
        link: "https://www.youtube.com/watch?v=bedirwk95Oc",
        "": "",
    },
    {
        type: "Movies",
        name: "The End of Medicine",
        category: "Documentary",
        author: "",
        description: "Animals, Health, Zoonotic diseases",
        link: "https://vimeo.com/495453559",
        "": "",
    },
    {
        type: "Movies",
        name: "The Farm",
        category: "Horror",
        author: "",
        description: "Animal rights, Vegan message",
        link: "https://www.youtube.com/watch?v=KknumPpFkWU",
        "": "",
    },
    {
        type: "Movies",
        name: "The Ghosts in Our Machine",
        category: "Documentary",
        author: "",
        description: "Animal rights, Animal welfare",
        link: "https://www.youtube.com/watch?v=DzJvcPmX79w",
        "": "",
    },
    {
        type: "Movies",
        name: "The Herd",
        category: "Action, Drama, Horror, Sci-fi, Thriller",
        author: "",
        description: "Animal rights, Animal welfare, Factory farms, Vegan message",
        link: "https://www.youtube.com/watch?v=kquTeEufVsg",
        "": "",
    },
    {
        type: "Movies",
        name: "The Ivory Game",
        category: "Documentary",
        author: "",
        description: "Animal rights, Animal welfare",
        link: "https://www.youtube.com/watch?v=3GPEKKaSmZY",
        "": "",
    },
    {
        type: "Movies",
        name: "The Last Pig",
        category: "Documentary",
        author: "",
        description: "Animal rights, Animal welfare, Farmers",
        link: "https://vimeo.com/215934124",
        "": "",
    },
    {
        type: "Movies",
        name: "The Marshall Plan",
        category: "Documentary",
        author: "",
        description:
            "Animals, Cancer, Dairy impact, Diabetes, Fitness, Health, Heart disease, Memory",
        link: "https://www.youtube.com/watch?v=SfQWK_PWcWQ",
        "": "",
    },
    {
        type: "Movies",
        name: "The Need to GROW",
        category: "Documentary",
        author: "",
        description: "Environment, Pollution, Sustainability",
        link: "https://www.youtube.com/watch?v=0pBYu4U525Y",
        "": "",
    },
    {
        type: "Movies",
        name: "The One And Only Ivan",
        category: "Adventure, Animation, Comedy, Family",
        author: "",
        description: "Animals, Animal welfare",
        link: "https://www.youtube.com/watch?v=I-uIQDRS4a8",
        "": "",
    },
    {
        type: "Movies",
        name: "The Plague Dogs",
        category: "Adventure, Animation, Drama",
        author: "",
        description: "Animals, Animal rights, Animal welfare",
        link: "https://www.youtube.com/watch?v=0vqWzquBh0c",
        "": "",
    },
    {
        type: "Movies",
        name: "The Pollinators",
        category: "Documentary",
        author: "",
        description:
            "Animal welfare, Climate change, Environment, Farmers, Pollution, Sustainability",
        link: "https://www.youtube.com/watch?v=rac_D_v-nrc",
        "": "",
    },
    {
        type: "Movies",
        name: "The Shame of Point Reyes",
        category: "Documentary",
        author: "",
        description: "Animal welfare, Environment, Pollution",
        link: "https://www.youtube.com/watch?v=e23CXCjcXxo",
        "": "",
    },
    {
        type: "Movies",
        name: "They're Trying to Kill Us",
        category: "Documentary",
        author: "",
        description: "Health, Human rights, Racism, Socio-economics, Vegan message",
        link: "https://vimeo.com/396022702",
        "": "",
    },
    {
        type: "Movies",
        name: "To Skin a Cat",
        category: "Documentary",
        author: "",
        description: "Animals, Animal rights, Animal welfare",
        link: "https://www.youtube.com/watch?v=xmwLrIbzxnE",
        "": "",
    },
    {
        type: "Movies",
        name: "Trolls",
        category: "Adventure, Animation, Comedy, Family, Fantasy, Musical",
        author: "",
        description: "Happiness",
        link: "https://www.youtube.com/watch?v=xyjm5VQ11TQ&t=1s",
        "": "",
    },
    {
        type: "Movies",
        name: "Turlock: The Documentary",
        category: "Documentary, Drama",
        author: "",
        description: "Animal rights, Animal welfare",
        link: "https://www.youtube.com/watch?v=0i-yB44DsY8",
        "": "",
    },
    {
        type: "Movies",
        name: "Tyke Elephant Outlaw",
        category: "Documentary",
        author: "",
        description: "Animal rights, Animal welfare",
        link: "https://www.youtube.com/watch?v=NvtW1dtuAcE",
        "": "",
    },
    {
        type: "Movies",
        name: "Unlocking the Cage",
        category: "Documentary",
        author: "",
        description: "Animal rights, Animal welfare",
        link: "https://www.youtube.com/watch?v=uKHheefCWMU",
        "": "",
    },
    {
        type: "Movies",
        name: "Up",
        category: "Adventure, Animation, Comedy, Family",
        author: "",
        description: "Animal welfare, Birds",
        link: "https://www.youtube.com/watch?v=HWEW_qTLSEE",
        "": "",
    },
    {
        type: "Movies",
        name: "Vanishing of the Bees",
        category: "Documentary",
        author: "",
        description: "Animals, Environment",
        link: "https://www.youtube.com/watch?v=A4WLFNkse3I",
        "": "",
    },
    {
        type: "Movies",
        name: "Vegan 2020",
        category: "Documentary",
        author: "",
        description:
            "Animal rights, Animal welfare, Environment, Factory farms, Health",
        link: "https://www.youtube.com/watch?v=rNiSAmnt1mc",
        "": "",
    },
    {
        type: "Movies",
        name: "Vegan: Everyday Stories",
        category: "Documentary",
        author: "",
        description: "Animal rights, Vegan message, Veganism",
        link: "https://www.youtube.com/watch?v=2qedrlO1Gg0",
        "": "",
    },
    {
        type: "Movies",
        name: "Virunga",
        category: "Documentary, War",
        author: "",
        description: "Animal rights, Human rights",
        link: "https://www.youtube.com/watch?v=wxXf2Vxj_EU",
        "": "",
    },
    {
        type: "Movies",
        name: "Virunga: Gorillas in Peril",
        category: "Documentary, War",
        author: "",
        description: "Animals",
        link: "n/a",
        "": "",
    },
    {
        type: "Movies",
        name: "Watermark",
        category: "Documentary",
        author: "",
        description: "Environment, Water",
        link: "https://www.youtube.com/watch?v=QOPLs_ogF-0",
        "": "",
    },

    {
        type: "Movies",
        name: "Watership Down",
        category: "Action, Adventure, Animation, Drama, Fantasy, Series",
        author: "",
        description: "A group of rabbits flee their doomed warren and face many dangers to find and protect their new home.",
        link: "https://www.youtube.com/watch?v=Jq73sIty43k&t=1s",
        "": "",
    },
    {
        type: "Movies",
        name: "Watson",
        category: "Documentary",
        author: "",
        description: "Animal rights, Animal welfare, Marine life",
        link: "https://www.youtube.com/watch?v=GUvH3kpjQhQ",
        "": "",
    },
    {
        type: "Movies",
        name: "We Are One",
        category: "Documentary",
        author: "",
        description: "Animal welfare, Human rights, Socio-economics",
        link: "https://www.youtube.com/watch?v=QMp7noQe8V4",
        "": "",
    },
    {
        type: "Movies",
        name: "Whale Wars",
        category: "Documentary, Series",
        author: "",
        description: "Animal rights, Animal welfare, Marine life",
        link: "https://www.youtube.com/watch?v=h6gqkSuDlhI",
        "": "",
    },
    {
        type: "Movies",
        name: "What's For Dinner?",
        category: "Documentary",
        author: "",
        description:
            "Animal rights, Animal welfare, Environment, Factory farms, Health",
        link: "https://www.youtube.com/watch?v=cwtMphRuhAg",
        "": "",
    },
    {
        type: "Movies",
        name: "White God",
        category: "Drama, Thriller",
        author: "",
        description: "Animals, Animal welfare",
        link: "https://www.youtube.com/watch?v=kIGz2kyo26U",
        "": "",
    },
    {
        type: "Movies",
        name: "Year of the Dog",
        category: "Comedy, Drama",
        author: "",
        description: "Animal rights, Vegan character, Vegan message",
        link: "https://www.youtube.com/watch?v=LSiYb4P0vDk&t=1s",
        "": "",
    },
    {
        type: "Movies",
        name: "Blackfish",
        category: "Documentary",
        author: "",
        description: "Animals, Orcas",
        link: "https://www.youtube.com/watch?v=fLOeH-Oq_1Y",
        "": "",
    },
    {
        type: "Movies",
        name: "The Cove",
        category: "Documentary",
        author: "",
        description: "Animals, Dolphins",
        link: "https://www.youtube.com/watch?v=jHaLJOYqvUQ",
        "": "",
    },

    {
        type: "Movies",
        name: "Okja",
        category: "",
        author: "",
        description: "Okja is a 2017 science-fantasy action-adventure film directed by Bong Joon-ho with a screenplay by Bong and Jon Ronson from a story by Bong.",
        link: "https://www.youtube.com/watch?v=AjCebKn4iic&ab_channel=Netflix",
        "": "",
    },
]
